import { responsive, useTheme } from '@wci-tech/core-ui';
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { getContainerStyles } from '@/utils';

export const useStyles = (isDark: boolean) => {
  const { theme } = useTheme();

  return useMemo(
    () => ({
      container: css`
        ${getContainerStyles(theme)};
        ${responsive.create({
          paddingTop: {
            default: theme.spacing.get(56),
            md: theme.spacing.get(44),
            lg: theme.spacing.get(116),
          },
          paddingBottom: {
            default: theme.spacing.get(52),
            md: theme.spacing.get(44),
            lg: theme.spacing.get(116),
          },
        })}
      `,
      comingSoonText: css`
        color: ${isDark ? theme.colors.commonColors.white : '#212121'};
        font-weight: ${theme.fonts.weight.medium};

        ${responsive.create({
          fontSize: {
            default: theme.fonts.size.xxl,
            md: theme.fonts.size['5xl'],
            lg: theme.fonts.size['6xl'],
          },
        })}
      `,
      btnIcon: css`
        svg {
          stroke-width: 0.6;
        }
      `,
    }),
    [theme, isDark],
  );
};
